import { render, staticRenderFns } from "./MiniproLiveForm.vue?vue&type=template&id=12a66f8e&scoped=true&"
import script from "./MiniproLiveForm.vue?vue&type=script&lang=js&"
export * from "./MiniproLiveForm.vue?vue&type=script&lang=js&"
import style0 from "./MiniproLiveForm.vue?vue&type=style&index=0&id=12a66f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a66f8e",
  null
  
)

export default component.exports